<div class="container">
  <!-- section title -->

  <div class='spacer-20'></div>

  <h2 class="section-title wow fadeInUp">{{ 'sections.programs.inProgressProgram.titleText' | translate }}!</h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-12">
      <!-- timeline wrapper -->
      <div class="timeline edu rounded bg-white shadow-dark padding-30 overflow-hidden">

        <kdn-curriculum-in-development>

        </kdn-curriculum-in-development>

      </div>
    </div>
  </div>
</div>
